import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { TEXTAREA_ROW_LENGTH } from '../../../constants/constants';
import validCharacters from '../../../constants/valid-characters';
import {
  IAddProcess,
  IUpdateProcess,
} from '../../../models/forms/IAddUpdateProcess';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { IMultiSelectOption, IOption } from '../../../models/ICommon';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import {
  DimensionDataValidateSchema,
  ProcessValidateSchema,
} from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import DefaultModalDraggable from '../../../shared-components/modal/default-modal-draggable';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import React, { useEffect, useState } from 'react';
import DimensionTypeEnum from '../../../constants/enums/dimension-types';
import { formatMessage } from '../../../translations/format-message';
import {
  DownIcon,
  EditIcon,
  RemoveIcon,
  RoundTabIcon,
  UpIcon,
} from '../../../shared-components/svgs/svgs';
import { MultiSelect } from 'react-multi-select-component';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';

interface IProps extends IAddEditFormProps<any> {
  processTypeOptions: IOption[];
  processDimensionData?: any;
  processOptions: any[];
  selectedProcesses: any[];
}

const AddDimensionDataForm = ({
  id,
  initialValues,
  isLoading,
  processTypeOptions,
  submitHandler,
  onModalClosed,
  processDimensionData,
  processOptions,
  selectedProcesses,
}: IProps) => {
  // const [dimensionData, setDimensionData] = useState<any[]>([]);
  const [selectedDimension, setSelectedDimension] = useState<any>(null);
  const [selected, setSelected] = useState([]);
  const removeOption = (option: any) => {
    setSelected((prev) => prev.filter((item) => item.value !== option.value));
  };

  // useEffect(() => {
  //   if (selectedProcesses) {
  //     setSelected(selectedProcesses);
  //   }
  // }, [selectedProcesses]);

  // useEffect(() => {
  //   if (processDimensionData) {
  //     setDimensionData(processDimensionData);
  //   }
  // }, [processDimensionData]);
  const selectedIds = new Set(
    initialValues?.Process?.map((p: any) => p.Id) ?? []
  );

  // Merge all processes with selection
  const mergedProcessOptions = processOptions.map((p: any) => ({
    ...p,
    ProcessId: p.Id,
    IsSelected: selectedIds.has(p.Id), // ✅ checked if API contains it
    MessagesType:
      initialValues?.Process?.find((x: any) => x.Id === p.Id)?.MessagesType ??
      -1,
  }));
  return (
    <>
      {/* <DefaultModalDraggable
        onModalClosed={onModalClosed}
        headerText='add_dimension_data'
        isLoading={isLoading}
        className="addProcess"
        saveUpdateBtnText={id < 0 ? 'save' : 'update'}
        cancelBtnText={'cancel'}
      > */}
      <Formik
        initialValues={{...initialValues, Process: mergedProcessOptions}}
        enableReinitialize
        validationSchema={DimensionDataValidateSchema}
        validateOnBlur={false}
        validate={(values) => {
          const errors: any = {};
          const processes = values.Process || [];
          if (!processes.some((p: any) => p.IsSelected)) {
            errors.Process = 'atleast_a_process';
            return errors;
          }

          // If any selected process doesn't have a valid MessagesType, set a form-level error
          const invalidType = processes.some(
            (p: any) => p.IsSelected && (p.MessagesType === undefined || p.MessagesType === null || Number(p.MessagesType) < 0)
          );
          if (invalidType) {
            errors.MessageType = 'select_dimension_type';
          }

          return errors;
        }}
        // onSubmit={async (values) => {
        //   submitHandler({
        //     ...values,
        //     ProcessID: selected.map((item) => Number(item.value)),
        //     MessagesType: Number(values.MessagesType),
        //     // .join(','),
        //   });
        // }}
        onSubmit={async (values) => {
          const payload = {
            TenantId: Number(getTenantIdFromLocalStorage()),
            Messages: values.Messages,
            Pixel: values.Picxel || 0,

            DimensionProcesses: values.Process
              .filter((p: any) => p.IsSelected)
              .map((p: any) => ({
                Id: p.ProcessId, // ✅ Correct key
                MessagesType: Number(p.MessagesType),
              })),
          };
          submitHandler(payload);
        }}
      >
        {({ values, setFieldValue, errors, submitCount }) => {
          // console.log(initialValues, 'initialValues');
          const processError =
            typeof errors.Process === 'string' ? errors.Process : undefined;
          const typeError = typeof errors.MessageType === 'string' ? errors.MessageType : undefined;
          return (
            <Form className="process-form dimesnion-data">
              {isLoading && <FormLoader loading={isLoading} />}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={true}
                        label="messages"
                      />
                      <Field
                        data-testid="testMessages"
                        className="form-control"
                        name="Messages"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  {processError && submitCount > 0 && (
                    <div className="invalid-feedback d-block errorMessage">
                      {formatMessage(processError)}
                    </div>
                  )}
                  {typeError && submitCount > 0 && (
                    <div className="invalid-feedback d-block errorMessage">
                      {formatMessage(typeError)}
                    </div>
                  )}
                  <div className="tableDevices dimension-table-data tableDesign">
                    <div className="table-responsive">
                      <div className="react-bootstrap-table">
                        <table className="table table-bordered table-striped border">
                          <thead>
                            <tr>
                              <th>{formatMessage('show')}</th>
                              <th>{formatMessage('process')}</th>
                              <th>{formatMessage('type')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.Process &&
                              values.Process.map((item: any, index: number) => (
                                <tr key={`${item.Id}-${index}`}>
                                  <td>
                                    <input
                                      name={`Process.${index}.IsSelected`}
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        setFieldValue(
                                          `Process.${index}.IsSelected`, e.target.checked
                                          // {
                                          //   IsSelected: e.target.checked,
                                          //   ProcessId: item.Id,
                                          // }
                                        );
                                        // console.log(values, 'values on change')
                                      }}
                                      aria-label={`Hide ${item.ProcessName}`}
                                    />
                                  </td>
                                  <td>{item.ProcessName}</td>
                                  <td>
                                    <Field name={`Process.${index}.MessagesType`}>
                                      {({ field, form }) => (
                                        <select
                                          className="form-control"
                                          {...field}
                                          onChange={(e) => {
                                            const selectedType = e.target.value;
                                            setFieldValue(
                                              `Process.${index}.MessagesType`,
                                              selectedType
                                            );
                                          }}
                                        >
                                          {processTypeOptions.map((opt) => (
                                            <option
                                              key={opt.id}
                                              value={opt.id}
                                              disabled={opt.disabled}
                                            >
                                              {formatMessage(
                                                opt.value.toLowerCase()
                                              )}
                                            </option>
                                          ))}
                                        </select>
                                      )}
                                    </Field>
                                    {/* <Field
                                  name={`processOptions.${index}.MessagesType`}
                                  as={FormikFormSelect}
                                  options={processTypeOptions}
                                  className="form-control"
                                /> */}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* {processError && submitCount > 0 && (
                    <div className="invalid-feedback d-block">
                      {formatMessage(processError)}
                    </div>
                  )} */}
                </div>
              </Modal.Body>
              <ModalFooter
                id={id}
                onModalClosed={onModalClosed}
                isLoading={isLoading}
                saveNextBtn={'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
      {/* </DefaultModalDraggable> */}
    </>
  );
};

export default AddDimensionDataForm;
